import { apiEndpoints } from "core/api/apiEndpoints";
import { httpRequest } from "core/api/httpRequest";

// get country selection data
const getCountrySelectionList = () => {
  return httpRequest(apiEndpoints.countrySelectionList, "get");
};

// To save country selection
const saveCountrySelection = (payload: any) => {
  return httpRequest(apiEndpoints.countrySaveSettings, "post", payload);
};

// To get currently selected country
const getCountrySelection = () => {
  return httpRequest(apiEndpoints.getSettings, "post");
};

export { getCountrySelectionList, saveCountrySelection, getCountrySelection };
